// Base API URL
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

// Other API related constants
export const API_TIMEOUT = 30000; // 30 seconds
export const API_HEADERS = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};

// API endpoints
export const ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh',
  },
  SETTINGS: {
    POSITIONS: '/settings/positions',
    ROMBEL: '/settings/rombel',
  },
  // Add more endpoints as needed
};
